// CultivarsManagementPage.js

import { useState, useEffect, useContext } from "react";
import { useFetch } from "use-http";
import { UserContext } from "../App";
import { getDBURL } from "../components/Utils/Utils";
import { getLabelByIndex, } from "../components/Utils/RBGUtils";
import { useErrorLogger } from '../components/Base components/Logger';

import CultivarsListTable from "../components/Cultivars/CultivarsListTable";

const CultivarsManagement = () => {
    const userData = useContext(UserContext);
    const { DBlogError } = useErrorLogger();
    const { get } = useFetch(getDBURL());

    const [cultivarsList, setCultivarsList] = useState([]);
    const [cultivarFullPropertiesList, setCultivarFullPropertiesList] = useState([]);

    const loadCultivarsList = async () => {
        try {
            const response = await get("/loadCultivars/dt=" + Date.now());

            // Check if the response is successful
            if (!response.success) {
                throw new Error(`HTTP error! ${response.message}`);
            }

            const data = response.result;
            if (data && data.length > 0) {
                const cultivars = data.map(cu => ({
                    CultivarID: cu.CultivarID,
                    Name: cu.CultivarName,
                    Company: cu.Company === null ? '' : cu.Company, 
                    Brand: cu.Brand === null ? '' : cu.Brand,   
                    Mother: cu.Mother === null ? '' : cu.Mother,
                    Father: cu.Father === null ? '' : cu.Father,
                    Rootstock: cu.Rootstock === null ? '' : cu.Rootstock,
                    FruitColor: cu.Type === null ? '' : getLabelByIndex("Type", cu.Type),
                    Harvest: cu.Harvest === null ? '' : getLabelByIndex("Harvest", cu.Harvest),
                    // BudBreak: cu.BudBreak === null ? '' : getLabelByIndex("BudBreak", cu.BudBreak),
                    // RainResistance: cu.RainResistance === null ? '' : getLabelByIndex("RainResistance", cu.RainResistance),
                    // Chilling: cu.Chilling === null ? '' : getLabelByIndex("Chilling", cu.Chilling),
                    Year: cu.YearOfAddition
                }));

                // Set the cultivars list state
                setCultivarsList(cultivars);
                setCultivarFullPropertiesList(data);
            }
        } catch (error) {
            console.error('🔴 Error in function loadCultivarsList >> ', error.message);

            // Construct error object
            const errorDetails = {
                error: error.message,
                parameters: {},
                userName: userData?.user?.name || 'Unknown User',
                moduleName: 'CultivarsManagement',
                functionName: 'loadCultivarsList',
            };

            DBlogError(errorDetails);
        }
    };

    useEffect(() => {
 
        // Call the function to load cultivars data
        loadCultivarsList();
    }, []);

    return <CultivarsListTable 
        cultivarsList={cultivarsList} 
        cultivarFullPropertiesList={cultivarFullPropertiesList}
        loadCultivarsList={loadCultivarsList}
        />;
};

export default CultivarsManagement;

